module.exports = __webpack_public_path__ + "static/media/m (3).c1b43313.jpg";